import React from 'react';
import { Box, Typography, ToggleButtonGroup, ToggleButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Profile } from '../types';

interface EmploymentTypeSelectorProps {
  profile: Profile;
  handleEmploymentTypeChange: (event: React.MouseEvent<HTMLElement>, newEmploymentType: string) => void;
}

const EmploymentTypeSelector: React.FC<EmploymentTypeSelectorProps> = ({
  profile,
  handleEmploymentTypeChange
}) => {
  const { t } = useTranslation();

  return (
    <Box>
      <ToggleButtonGroup
        value={profile.employmentType}
        exclusive
        onChange={handleEmploymentTypeChange}
        aria-label="employment type"
        sx={{ 
          '& .MuiToggleButton-root': {
            py: 0.5,
            px: 2,
            fontSize: '0.875rem'
          }
        }}
      >
        <ToggleButton 
          value="EMPLOYEE" 
          aria-label="employee"
          sx={{
            '&.Mui-selected': {
              backgroundColor: 'secondary.main',
              color: 'white',
              '&:hover': {
                backgroundColor: 'secondary.dark',
              }
            }
          }}
        >
          {t('screening_profile.employee')}
        </ToggleButton>
        <ToggleButton 
          value="SELF_EMPLOYED" 
          aria-label="self employed"
          sx={{
            '&.Mui-selected': {
              backgroundColor: 'secondary.main',
              color: 'white',
              '&:hover': {
                backgroundColor: 'secondary.dark',
              }
            }
          }}
        >
          {t('screening_profile.self_employed')}
        </ToggleButton>
        <ToggleButton 
          value="PENSION" 
          aria-label="pensioned"
          sx={{
            '&.Mui-selected': {
              backgroundColor: 'secondary.main',
              color: 'white',
              '&:hover': {
                backgroundColor: 'secondary.dark',
              }
            }
          }}
        >
          {t('screening_profile.pensioned')}
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default EmploymentTypeSelector; 